import { render, staticRenderFns } from "./content-loader.vue?vue&type=template&id=d2996030"
import script from "./content-loader.vue?vue&type=script&lang=js"
export * from "./content-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports